import "../../../../assets/presentation/components/controls/button/button-Dfn562Dm.css";
import { Ripple } from "../ripple/ripple2.js";
/* empty css       */
import { Icon, IconVariation } from "../icon/icon2.js";
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/controls/button/button.tsx
var ButtonPriority = /* @__PURE__ */ function(ButtonPriority) {
	ButtonPriority["PRIMARY"] = "primary";
	ButtonPriority["SECONDARY"] = "secondary";
	ButtonPriority["TERTIARY"] = "tertiary";
	ButtonPriority["TEXT"] = "text";
	return ButtonPriority;
}({});
var ButtonSize = /* @__PURE__ */ function(ButtonSize) {
	ButtonSize["NORMAL"] = "normal-size";
	ButtonSize["SMALL"] = "small-size";
	ButtonSize["XS"] = "xs-size";
	return ButtonSize;
}({});
var Button = ({ children, className, isDisabled, isPending = false, rippleLight, rippleDark, rounded, error, maxRounded, circle, onClick, onDisableButtonClick, priority = "primary", size = "normal-size", style, fullHeight = false, ...otherProps }) => {
	const onHandleButtonClick = (event) => {
		if (isDisabled || isPending) onDisableButtonClick?.(event);
		else onClick?.(event);
	};
	const effectiveDisabled = isDisabled || isPending;
	return /* @__PURE__ */ jsx(Ripple, {
		...otherProps,
		light: rippleLight,
		dark: rippleDark,
		onClick: onHandleButtonClick,
		className: classNames(className, "button", priority, size, {
			rounded,
			error,
			circle,
			"disabled": effectiveDisabled,
			"max-rounded": maxRounded,
			"full-height": fullHeight
		}),
		style,
		component: "button",
		children: isPending ? /* @__PURE__ */ jsxs("div", {
			className: "button-loading-container",
			children: [/* @__PURE__ */ jsx(Icon, {
				icon: "sync",
				variation: IconVariation.OUTLINED,
				className: "button-loading-spinner"
			}), children]
		}) : children
	});
};
var ErrorButton = ({ children, ...otherProps }) => /* @__PURE__ */ jsx(Button, {
	error: true,
	...otherProps,
	children
});
var RoundedButton = ({ children, ...otherProps }) => /* @__PURE__ */ jsx(Button, {
	rounded: true,
	...otherProps,
	children
});
var CircleButton = ({ children, ...otherProps }) => /* @__PURE__ */ jsx(Button, {
	circle: true,
	...otherProps,
	children
});
//#endregion
export { Button, ButtonPriority, ButtonSize, CircleButton, ErrorButton, RoundedButton };

//# sourceMappingURL=button2.js.map